// extracted by mini-css-extract-plugin
module.exports = {"main":"content_main__tnbHs","loading":"content_loading__b7qMF","content":"content_content__KQT24"};